'use strict';

class RcmFatCallbacks {
    constructor(fat) {
        this.fat = fat;
    }

    // On form ready (all facets loaded)
    onReady() {
        this.fat.modules.showPreSearchModule();
        this.fat.loader.hide();
    }

    // On before do search
    onBeforeSearch() {
        this.fat.loader.show();
    }

    // On after do search
    onAfterSearch() {
        this.fat.browser.updateHistory();

        if ($('.off-canvas').is('.is-open')) {
            $('.off-canvas').foundation('close');
        }

        this.fat.form.clearFacetFields();
    }

    // On results
    onResults(data, isFacetFilterOnDesktop, isMapMove = false) {
        var self = this;

        // If first page, "clear list"
        var clearList = data.page > 0 ? false : true;

        // Track Google Analytics
        if ('undefined' !== typeof data.nbHits && clearList) {
            this.fat.google.updateGoogleAnalytics(data.nbHits);
        }

        // Custom sort and ranking
        var firstBucket = []; // accepting new students AND have Oscar Peterson School as Teaching Location, sorted A-Z
        var secondBucket = []; // accepting new students AND RCM Certified AND within 5 km, sorted by distance
        var thirdBucket = []; // accepting new students, not RCM Certified, sorted by distance
        var fourthBucket = []; // not accepting new students, sorted by distance

        data.hits.forEach(hit => {
            if (hit.acceptingNewStudents === true) {
                if (hit.teachingLocation && hit.teachingLocation.includes('Oscar Peterson School of Music (Toronto)')) {
                    firstBucket.push(hit);
                } else if (hit.rcmCredentials && hit.rcmCredentials.includes('RCM Certified') && hit._rankingInfo.geoDistance <= 5000) {
                    secondBucket.push(hit);
                } else {
                    thirdBucket.push(hit);
                }
            } else {
                fourthBucket.push(hit);
            }
        });

        // Custom sorting
        // sorted A-Z
        firstBucket.sort((a, b) => self._helperSortAlpha(a, b));

        // sorted by distance, but if the same distance - alphabetically
        this._helperSortHitsByDistanceAndAlpha(secondBucket);
        this._helperSortHitsByDistanceAndAlpha(thirdBucket);
        this._helperSortHitsByDistanceAndAlpha(fourthBucket);

        data.hits = [...firstBucket, ...secondBucket, ...thirdBucket, ...fourthBucket];

        // Populate global data object
        if (clearList) {
            this.fat.data = [];
        }

        this.fat.data.push(data);

        this.sortResultsByPage(data);

        this.fat.mapCurrentPage = 0;
        this.fat.mapPageGroup = [0, 3];

        // Transform data in HTML/visual
        this.fat.resultsFilters.set(data, isFacetFilterOnDesktop);
        this.fat.resultsFilters.setAppliedFilters();
        
        if (isMapMove) {
            this.fat.resultsMap.set(false, true, false); // clear, onMapMove, onPageChange
        } else {
            this.fat.resultsMap.set(clearList, isMapMove, false); // clear, onMapMove, onPageChange
        }

        // render the results list
        this.fat.resultsList.set();

        // Final effects
        this.fat.modules.showPosSearchModule();
        this.fat.loader.hide();

        // If first page, scroll to the top of the page
        if (clearList) {
            this.fat.htmlAndBody.stop(true, false).animate({ scrollTop: 0 }, 250);
        }

        // Console debug
        //if (console && console.log) {
        //    console.log('RcmFatCallbacks.onResults', clearList, data);
        //}
    }

    _helperSortAlpha(a, b) {
        var nameA = a.lastName.toLowerCase();
        var nameB = b.lastName.toLowerCase();

        if (nameA < nameB) {
            return -1;
        } else if (nameA > nameB) {
            return 1;
        } else {
            return 0;
        }
    }

    _helperSortHitsByDistanceAndAlpha(hits) {
        var self = this;

        hits.sort((a, b) => {
            if (a._rankingInfo.geoDistance < b._rankingInfo.geoDistance) {
                return -1;
            } else if (a._rankingInfo.geoDistance > b._rankingInfo.geoDistance) {
                return 1;
            } else {
                return self._helperSortAlpha(a, b);
            }
        });
    }

    sortResultsByPage(data) {

        var self = this;
        var resultsPageKey = 0;

        self.fat.resultsPaged = [{ hits: {}, count: 0 }];

        $.each(data.hits, function (k, v) {

            var uniqueId = self.fat._helperGetTeacherUniqueId(v.objectID, v._rankingInfo.matchedGeoLocation.lat, v._rankingInfo.matchedGeoLocation.lng);

            self.fat.resultsPaged[resultsPageKey] = self.fat.resultsPaged[resultsPageKey] ? self.fat.resultsPaged[resultsPageKey] : { hits: {}, count: 0 };

            // if the group size has reached the page size
            if (self.fat.resultsPaged[resultsPageKey].count === self.fat.mapPageSize) {
                resultsPageKey = resultsPageKey + 1;
                self.fat.resultsPaged[resultsPageKey] = { hits: {}, count: 0 };
            }

            var currentResultsPageGroup = self.fat.resultsPaged[resultsPageKey];
            currentResultsPageGroup.hits[uniqueId] = {};
            currentResultsPageGroup.hits[uniqueId]["item"] = v;

            self.fat.resultsPaged[resultsPageKey].count++;

        });

    }

}
